import React, {Component} from "react";
import './styles.scss';
import ModalWrapper from "../ModalWrapper";
import Translator from "../../../requests/apa/Translator";
import { getTypeModal } from "./const";
import { formatByThree } from "./utils"
import Asset from "../../../requests/apa/Asset";
import {getOPTLinkDevices} from '../../../../src/requests/loader';
import Device from "../../../devices/device";
import {getOtpTimeConfiguration } from '../../../utils/Utils';
import { BACK, DELETE, GET, SUCCESFULL,IPTELMEX,LOGIN,REGISTER,HIDE,MODALOVERLAYMAIN,MODALLANDINGTELMEX,DEMODEL,DESLEP } from '../../../AAFPlayer/constants';
import RegisterOTP from "../../../authentication/Register/RegisterOTP";
import { receiveIsLoggedIn, fetchPushSession } from '../../../reducers/user';
import {setMetricsEvent} from "../../../actions/metrics";
import { connect } from 'react-redux';
import { showModal, HIDE_MODAL } from '../../../actions/modal';
import { fetchLinealChannels } from '../../../actions/payway';
import LoginLogicOTP from '../../../../src/authentication/Login/LoginLogicOTP';
import { loginOTP } from '../../../requests/loader';
import { ca } from "date-fns/locale";
import store from '../../../store';

class LoginQR extends Component {
    constructor(props){
        super (props);
        const { typeModal, dataLinkDeviceOTP } = this.props.response;
        const { url , code, qrImage } = dataLinkDeviceOTP || {};
        this.labels = getTypeModal(typeModal);
        this.url = url || '';
        this.code = code || '';
        this.qrImage = qrImage || '';
        this.formattedCode = formatByThree(this.code);

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.pollApi = this.pollApi.bind(this);
        this.keys = Device.getDevice().getKeys();
        this.otpTimeConfiguration = getOtpTimeConfiguration();
        this.pollTimeout = null;
        this.isMountedd = false;
        this.polling = false;
        this.typeSession = typeModal;
        this.timeInMilisecondsOTP =  this.otpTimeConfiguration.time_in_seconds * 1000;        
        this.otpConfigurationEnable =  this.otpTimeConfiguration.enable;
        this.state = {expiredCode: false}
        this.expiredCodeText = Translator.get('Onboarding2_Input_TextoError_CodigoExpirado2', 'Código expirado');
    }

    closeModal = (e) => {
        this.stopPolling();
        const dispatcher = (this.props && this.props.dispatch) || (store && store.dispatch);
        if (dispatcher && typeof dispatcher === 'function') {
            dispatcher({ type: HIDE_MODAL });
        }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    async handleKeyPress(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case BACK:

                this.statusCodeOTP(DELETE, this.code);
                this.closeModal(e);
            break;
            default:
        }
    }

    componentDidMount(){
        if (document && document.addEventListener) {
            document.addEventListener('keydown', this.handleKeyPress, true);
        }
        this.isMountedd = true;
        this.startPolling();
    }

    startPolling = () => {
        if (this.polling) return;
        this.polling = true;
        this.pollApi(); 
    };

    stopPolling = () => {
        this.polling = false;
        if (this.pollTimeout) {
            clearTimeout(this.pollTimeout);
            this.pollTimeout = null;
        }
    };

    statusCodeOTP = async (type, code) => {
        return await getOPTLinkDevices(type, code);
    };

    scheduleNextPoll = () => {
        if (!this.isMountedd || !this.polling) return;
        this.pollTimeout = setTimeout(this.pollApi, this.timeInMilisecondsOTP);
    };

    componentWillUnmount() {
        if (document && document.removeEventListener) {
            document.removeEventListener('keydown', this.handleKeyPress, true);
        }
        this.stopPolling();
    }

    pollApi = async () => {
        if (!this.isMountedd || !this.polling) return;

        const result = await this.statusCodeOTP(GET, this.code);

        if (result && result.status && result.status === SUCCESFULL) {
            this.registerLogicOTP = new RegisterOTP(this.props);
            this.loginLogicOTP = new LoginLogicOTP(this.props);
            this.stopPolling();
            this.statusCodeOTP(DELETE, this.code);

            switch (this.typeSession) {
                case IPTELMEX:
                case REGISTER:
                case LOGIN:
                    setTimeout(() => {
                        this.closeModal();
                    }, 1500);
                    const newObject = {response: result.user_data};
                    await this.loginLogicOTP.loginFLow(newObject, loginOTP);
                    break;
                default:
                    break;
            }
        } else if (result && result.code) {
           this.setState({expiredCode: true});
        } else {
             if(this.otpTimeConfiguration && this.otpTimeConfiguration.enable){
                this.scheduleNextPoll();
            }
        }
    };

    getTextStep1(step_1){
        const textStep1 = Translator.get(step_1);
        const formatted = textStep1.replace(DEMODEL, DESLEP);
        const partsStep1 = formatted.split("|");
        return partsStep1;
    }

    render(){
        const {icon_header, title, step_1, step_1_complement, step_2, step_3 } = this.labels;
        const { expiredCode } = this.state;
        const partsStep1 = this.getTextStep1(step_1);
        
        return (
            <ModalWrapper classNameComponent='modal-login-qr' className='modal-login-qr_container'>
                <div className="modal-login-qr_icon_header">
                    <img src={Asset.get(icon_header)} alt="logo header" />
                </div>

                <div className="modal-login-qr_info_container">
                    <h1 className="modal-login-qr_title">{Translator.get(title)}</h1>

                    <div className="modal-login-qr_content"> 
                        <div className="modal-login-qr_column_left">
                            <div className="modal-login-qr_step_container">
                                <div className="modal-login-qr_step_number">
                                    {Translator.get('Onboarding2_Texto_Digito_Paso1')}
                                </div>
                                <div className="modal-login-qr_step_info">
                                    <p className="modal-login-qr_step_info_text">
                                        {partsStep1[0]}
                                    </p>
                                    <p className="modal-login-qr_step_info_text">
                                        {partsStep1[1]}
                                    </p>

                                    <div  className="modal-login-qr_step_info_image">
                                        <img src={this.qrImage} alt="QR"/>
                                    </div>

                                    {!expiredCode && (<p className="modal-login-qr_step_info_text">
                                        {Translator.get(step_1_complement)}
                                    </p>)}

                                   {( expiredCode &&  <p className="modal-login-qr_step_info_text_expired">
                                        {/* Cambiar por lo que trae el servicio */}
                                        {this.expiredCodeText}
                                        </p>
                                    )}

                                    <p className="modal-login-qr_step_info_url">
                                        {/* Cambiar por lo que trae el servicio */}
                                        {this.url}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="modal-login-qr_column_right">
                            <div className="modal-login-qr_step_container">
                                <div className="modal-login-qr_step_number">
                                    {Translator.get('Onboarding2_Texto_Digito_Paso2')}
                                </div>
                                <div className="modal-login-qr_step_info">
                                    <p className="modal-login-qr_step_info_text">
                                        {Translator.get(step_2)}
                                    </p>

                                    <p className="modal-login-qr_step_info_code">
                                        {/* Cambiar por lo que trae el servicio */}
                                        {this.formattedCode}
                                    </p>
                                </div>
                            </div>

                            <div className="modal-login-qr_step_container">
                                <div className="modal-login-qr_step_number">
                                    {Translator.get('Onboarding2_Texto_Digito_Paso3')}
                                </div>
                                <div className="modal-login-qr_step_info">
                                    <p className="modal-login-qr_step_info_text">
                                        {Translator.get(step_3)}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </ModalWrapper>
        )
    }
}

export default connect(null, {showModal, receiveIsLoggedIn, setMetricsEvent, fetchPushSession, fetchLinealChannels})(LoginQR);



// WEBPACK FOOTER //
// ./src/components/Modal/LoginQR/LoginQR.jsx